import { jsx as _jsx } from "react/jsx-runtime";
import { SelectionProvider } from "./SelectionContext";
import { DragDropProvider } from "./DragDropContext";
import { EditProvider } from "./EditContext";
import { ChangeTrackingProvider } from "./ChangeTrackingContext";
/**
 * Combined provider that wraps all presentation plan contexts
 * This eliminates the need to nest multiple providers in the component tree
 */
export const PresentationPlanProvider = ({ children }) => {
    return (_jsx(SelectionProvider, { children: _jsx(DragDropProvider, { children: _jsx(EditProvider, { children: _jsx(ChangeTrackingProvider, { children: children }) }) }) }));
};
